import React from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";

// core components
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardFooter from "../../components/Card/CardFooter";
import CardIcon from "../../components/Card/CardIcon";

import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

const Tool = props => {
  const classes = useStyles();
  const { icon, title, value, color } = props;

  return (
    <Card>
      <CardHeader color={color} stats icon>
        <CardIcon color={color}>
          <Icon>{icon}</Icon>
        </CardIcon>
        <h3 className={classes.cardTitle}>{value}</h3>
      </CardHeader>
      <CardFooter stats>
        <div className={classes.stats}>
          <p>{title}</p>
        </div>
      </CardFooter>
    </Card>
  );
};

export default Tool;
